<template>
    <loading>
        <h2>Work in progress!</h2>
        <h2>
            We are working hard to implement this feature!
        </h2>
        <h2>
            <img src="/img/work-in-progress-wip.jpg" width="100" alt="WIP"/>
        </h2>
        <div>
            <router-link to="/" class="btn btn--block btn--secondary">Go back to the Dashboard</router-link>
        </div>
    </loading>
</template>

<script>
    export default {
        name: "Wip"
    }
</script>

<style scoped>

</style>